export class UploadError extends Error {
	code: number
	constructor(code: number, message: string) {
		super(message)
		this.code = code ?? 9999
	}
}
